const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 769,
    lg: 1024,
    xl: 1200,
  },
};

export default breakpoints;
